export default __webpack_public_path__ + "static/ustvnow-360-logo-retina-white-54b876e63ef945e7e8b067868cf419ec.png";